import { ethers } from "ethers";

async function fetchAccounts() {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const accounts = await provider.send("eth_requestAccounts", []);
  return { provider, accounts };
}

async function fetchHoneyBalance(provider, accounts) {
  const contract = new ethers.Contract(
    process.env.REACT_APP_HONEY_ADDRESS,
    process.env.REACT_APP_HONEY_ABI,
    provider
  );
  const balance = await contract.balanceOf(accounts[0]);
  return Number(ethers.utils.formatEther(balance)).toFixed(0);
}

async function fetchLpData(provider, accounts) {
  const lpStakingContract = new ethers.Contract(
    process.env.REACT_APP_LP_STAKING_ADDRESS,
    process.env.REACT_APP_LP_STAKING_ABI,
    provider
  );
  const lpContract = new ethers.Contract(
    process.env.REACT_APP_LP_ADDRESS,
    process.env.REACT_APP_LP_ABI,
    provider
  );
  const staked = await lpStakingContract.balanceOf(accounts[0]);
  const earned = await lpStakingContract.earned(accounts[0]);
  const balance = await lpContract.balanceOf(accounts[0]);
  return {
    staked: Number(ethers.utils.formatEther(staked)).toFixed(2),
    balance: Number(ethers.utils.formatEther(balance)).toFixed(2),
    earned: Number(ethers.utils.formatEther(earned)).toFixed(2),
  };
}

async function fetchOldContractStaked(provider, accounts) {
  const oldContract = new ethers.Contract(
    process.env.REACT_APP_STAKING_ADDRESS_OLD,
    process.env.REACT_APP_STAKING_ABI_OLD,
    provider
  );
  const stakesOld = await oldContract.getStakedBear(accounts[0]);

  return stakesOld;
}

async function fetchBearsOwned(provider, accounts) {
  const contract = new ethers.Contract(
    process.env.REACT_APP_BEAR_ADDRESS,
    process.env.REACT_APP_BEAR_ABI,
    provider
  );
  const balance = await contract.balanceOf(accounts[0]);
  return parseInt(balance);
}

async function fetchApproved(provider, accounts) {
  const bearContract = new ethers.Contract(
    process.env.REACT_APP_BEAR_ADDRESS,
    process.env.REACT_APP_BEAR_ABI,
    provider
  );
  const lpContract = new ethers.Contract(
    process.env.REACT_APP_LP_ADDRESS,
    process.env.REACT_APP_LP_ABI,
    provider
  );

  const bearStaking = await bearContract.isApprovedForAll(
    accounts[0],
    process.env.REACT_APP_STAKING_ADDRESS
  );
  const lpStaking = await lpContract.allowance(
    accounts[0],
    process.env.REACT_APP_LP_STAKING_ADDRESS
  );
  return {
    bears: bearStaking,
    lp: parseInt(lpStaking),
  };
}

/* ////////// */

async function fetchUserData() {
  const { provider, accounts } = await fetchAccounts();
  const stakesNew = [];
  const stakesNewHoney = [];
  const dataNew = [];
  var unclaimedHoney = 0;

  const newContract = new ethers.Contract(
    process.env.REACT_APP_STAKING_ADDRESS,
    process.env.REACT_APP_STAKING_ABI,
    provider
  );

  const stakesNewUnformatted = await newContract.stakesOf(accounts[0]);

  stakesNewUnformatted.map((stake, index) => {
    return stakesNew.push(parseInt(stake));
  });

  await Promise.all(
    stakesNew.map(async (bear, index) => {
      return stakesNewHoney.push(
        await newContract.calculateReward(accounts[0], bear)
      );
    })
  );

  stakesNewHoney.forEach((element, index) => {
    const formatted = Number(ethers.utils.formatEther(element));
    unclaimedHoney = (unclaimedHoney + formatted).toFixed(0);
  });

  stakesNew.forEach((element, index) => {
    dataNew.push({
      id: element,
      honey: ethers.utils.formatEther(stakesNewHoney[index]),
    });
  });

  const oldContractStaked = await fetchOldContractStaked(provider, accounts);

  return {
    dataNew: dataNew,
    stakesOld: oldContractStaked,
    honey: await fetchHoneyBalance(provider, accounts),
    totalStaked: dataNew.length + oldContractStaked.length,
    bearsOwned: await fetchBearsOwned(provider, accounts),
    lpData: await fetchLpData(provider, accounts),
    unclaimedHoney: unclaimedHoney,
    approved: await fetchApproved(provider, accounts),
  };
}

export { fetchUserData, fetchAccounts };
